// @flow
/** @jsx isolateComponent */

import { Modal } from '@zapier/common-components';
import { Button, Link, Text } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

type Props = {
  /** Title of the policy. */
  title: string,
  /** A description of what's changed in the policy. */
  tldr: string,
  /** URL of the policy page to view more. */
  url?: string,
  /** Callback for when acceptance button is clicked. */
  onAccept: () => void,
};

const Styles = labelStyles(__filename, {
  content: {
    margin: '0 20px',
    textAlign: 'center',
  },
});

const PolicyModal = (props: Props) => {
  return (
    <Modal maxWidth={580} overflowY="auto">
      <section css={Styles.content}>
        <Text tag="h1" textAlign="center" type="header800">
          We’ve updated the {props.title}
        </Text>
        <Text
          margin="20px 0 35px"
          tag="p"
          textAlign="center"
          type="bodyText800"
        >
          {props.tldr}
        </Text>
        <Button casing="uppercase" hasShadow={true} onClick={props.onAccept}>
          Accept
        </Button>
        {!!props.url && (
          <Text margin="15px 0 0" tag="p" textAlign="center" type="bodyText800">
            <Link href={props.url} target="_blank">
              Review the updated policy
            </Link>
          </Text>
        )}
      </section>
    </Modal>
  );
};

export default PolicyModal;
